"use strict";
/*
 * Copyright 2020 - MATTR Limited
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *     http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLS12381_BLINDING_FACTOR_LENGTH = exports.DEFAULT_BLS12381_G1_PUBLIC_KEY_LENGTH = exports.DEFAULT_BLS12381_G2_PUBLIC_KEY_LENGTH = exports.DEFAULT_BLS12381_PRIVATE_KEY_LENGTH = void 0;
var BlsKeyPair_1 = require("./BlsKeyPair");
Object.defineProperty(exports, "DEFAULT_BLS12381_PRIVATE_KEY_LENGTH", { enumerable: true, get: function () { return BlsKeyPair_1.DEFAULT_BLS12381_PRIVATE_KEY_LENGTH; } });
Object.defineProperty(exports, "DEFAULT_BLS12381_G2_PUBLIC_KEY_LENGTH", { enumerable: true, get: function () { return BlsKeyPair_1.DEFAULT_BLS12381_G2_PUBLIC_KEY_LENGTH; } });
Object.defineProperty(exports, "DEFAULT_BLS12381_G1_PUBLIC_KEY_LENGTH", { enumerable: true, get: function () { return BlsKeyPair_1.DEFAULT_BLS12381_G1_PUBLIC_KEY_LENGTH; } });
Object.defineProperty(exports, "BLS12381_BLINDING_FACTOR_LENGTH", { enumerable: true, get: function () { return BlsKeyPair_1.BLS12381_BLINDING_FACTOR_LENGTH; } });
//# sourceMappingURL=index.js.map